import router from '../../router';
import {getContacts, updateContact} from "../../api/contacts";

const state = {
    contacts:null,
    activeContact: null,
};

const actions = {
    getContacts: ({commit, state}, params) => {
        state.contacts = 'loading';
        getContacts(params).then(response => {
            commit('SET_CONTACTS', response);
        }).catch(e => {
            commit('app/ADD_MESSAGE', {text: 'Nie udało się pobrać kontaktów', type: error}, {root: true});
        })
    },
    updateActive:({commit, state}, data) => {
        updateContact(data, state.activeContact.id).then(response => {
        })
    }
}
const mutations = {
    SET_CONTACTS:(state, value) => {state.contacts = value},
    SET_ACTIVECONTACT:(state, value) => {state.activeContact = value}
};

const getters = {
    contacts: (state) => {return state.contacts},
}
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
